import { Routes } from '@angular/router';

const EmbedRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: ':slug',
        loadComponent: () => import('./embed-page.component'),
        data: {
          revalidate: 60,
        }
      },
      {
        path: ':slug/:options',
        loadComponent: () => import('./embed-page.component'),
        data: {
          revalidate: 60,
        }
      },
      {
        path: ':slug/:child/:options',
        loadComponent: () => import('./embed-page.component'),
        data: {
          revalidate: 60,
        }
      },
      {
        path: ':slug/**',
        loadComponent: () => import('./embed-page.component'),
        data: {
          revalidate: 60,
        }
      },
    ],
  },
];

export default EmbedRoutes;